// extracted by mini-css-extract-plugin
module.exports = {"container":"product-tags_container__YDGX5","isInset":"product-tags_isInset___1Jn5","tag":"product-tags_tag__i03wB"};